module.exports = __webpack_public_path__ + "static/media/checked-select.9b555001.svg";